{
    "save": "Speichern",
    "cancel": "Abbrechen",
    "back": "Zurück",
    "next": "Weiter",
    "submit": "Absenden",
    "loading": "Wird geladen...",
    "language": "Sprache",
    "languageDescription": "Wählen Sie die Sprache für Menüs, Schaltflächen und Erinnerungen.",
    "profile": {
        "title": "Profil",
        "description": "Verwalten Sie Ihr Profil und Ihre Einstellungen",
        "contactDetails": "Kontaktdaten",
        "languageGroup": "Sprache",
        "otherActions": "Weitere Aktionen",
        "changePassword": "Passwort ändern",
        "logout": "Abmelden",
        "incompleteTitle": "Profil unvollständig",
        "incompleteMessage": "Um Patient Watch zu nutzen, vervollständigen Sie zuerst Ihr Profil und ergänzen Sie alle als fehlend markierten Felder."
    },
    "nav": {
        "diaries": "Tagebücher"
    }
}
